import React from 'react'
import { route } from "@helpers"
import useAuth from "@hooks/useAuth"
import { Redirect, Route, RouteProps, useLocation } from "react-router"
import redirects from '@services/redirects'

export default function invited() {
    return ({ children, component, ...props }: RouteProps) => {
        const location = useLocation()
        const { user } = useAuth()
        
        if (!user) {
            redirects.on("customerLoggedIn", location.pathname)

            return <Redirect to={{
                pathname: route("welcome"),
                state: "invited"
            }} />
        }

        if (component) return <Route {...props} component={component} />
        return <Route {...props}>{children}</Route>    
    }
}